import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-children-sticker-banner',
  templateUrl: './children-sticker-banner.component.html',
  styleUrls: ['./children-sticker-banner.component.scss']
})
export class ChildrenStickerBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
